export default {
    profile: 'โปรไฟล์',
    name: 'ชื่อ นามสกุล',
    employeeNo: 'รหัสพนักงาน',
    employeeName: 'ชื่อพนักงาน',
    address: 'ที่อยู่',
    date: 'วันที่',
    time: 'เวลา',
    department: 'แผนก',
    group: 'กลุ่ม',
    startDate: 'วันเริ่ม',
    endDate: 'วันสิ้นสุด',
    status: 'สถานะการทำงาน',
    contact: 'ติดต่อ',
    email: 'อีเมล์',
    phoneNumber: 'เบอร์โทรศัพท์',
    checkInStatus: 'สถานะการเช็คชื่อ',
    viewAttendance: 'ข้อมูลการลงเวลา',
    attachmentFile: 'ไฟล์แนบ',
    checkInLocation: 'สถานที่',
    checkInDetail: 'รายละเอียดการลงเวลา',
    checkIn: 'เช็คอิน',
    jobId: 'รหัส',
    customerName: 'ลูกค้า',
    contactPerson: 'ผู้ติดต่อ',
    contactPhone: 'เบอร์ผู้ติดต่อ',
    origin: 'จุดเริ่มต้น',
    startTime: 'เวลาที่เริ่ม',
    startMilieage: 'เลขไมล์ก่อนเดินทาง',
    endTime: 'เวลาที่สิ้นสุด',
    endMilieage: 'เลขไมล์หลังเดินทาง',
    activities: 'กิจกรรม'
}
